<a class="link" [routerLink]="link" [target]="target">{{text}}</a>
